import styled from '@mui/system/styled';
import LoadingButton from "@mui/lab/LoadingButton";
import { TextField} from "@mui/material";

export const Customebtn = styled(LoadingButton)(({ theme, locale }) => ({
    "&:hover": {
        border: "none"
    },
    "&.Mui-disabled": {
        color: "grey !important",
        border: "none !important",
        backgroundColor: "#bcbcbc70 !important"
    },

    backgroundColor: " #008C8D  !important",
    fontSize: "1rem !important",
    width: "100% !important",
    border: "none",
    height: "1.0375em",
    boxSizing: "content-box",
    padding: " 16.5px 14px",
    borderRadius: "12px",

    "@media (min-width:600px)": {
        backgroundColor: " #008C8D  !important",
        fontSize: "1rem !important",

        width: "322px !important",
        height: "1.0375em",
        boxSizing: "content-box",
        padding: " 16.5px 14px",
        borderRadius: "12px",
        border: "none"
    }
}));
export const CustomeForm = styled(TextField)(({ theme, locale }) => ({
    padding: "0px !important",
    "& .MuiOutlinedInput-root": {
        borderRadius: "12px",
        boxShadow: "0 0 4px #bcbcbc !important",
    },
    '& .MuiSvgIcon-root': {
        color: '#008C8D ',
    },
    "& label.Mui-focused": {
        color: "#008C8D "
    },
    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "white"
    },

    "& .MuiInput-underline:after": {
        borderButtomColor: "#008C8D "
    },

    "& .MuiOutlinedInput-notchedOutline": {
        border: "none"
    },

    "& .MuiOutlinedInput-notchedOutline": {
        border: "none"
    },

    width: "100%",

    "& .MuiButton-root:hover": {
        border: "none"
    },
    "& .MuiInputLabel-root": {
        color: "#bcbcbc"
    },

    "@media (min-width:600px)": {
        width: "350px"
    }
}));